/**
 * ฟังก์ชัน hash ที่ใช้ได้ทั้งบน Cloudflare Workers และบน browser
 * ใช้ Web Crypto เท่านั้น ไม่พึ่ง Node built-in
 */

export function toHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    out += bytes[i]!.toString(16).padStart(2, '0');
  }
  return out;
}

/** SHA-256 ของข้อมูลไบนารี คืนค่าเป็น hex ตัวพิมพ์เล็ก 64 ตัวอักษร */
export async function sha256Hex(data: ArrayBuffer | Uint8Array | Blob): Promise<string> {
  let buffer: ArrayBuffer;
  if (data instanceof Blob) {
    buffer = await data.arrayBuffer();
  } else if (data instanceof Uint8Array) {
    buffer = data.slice().buffer;
  } else {
    buffer = data;
  }
  return toHex(await crypto.subtle.digest('SHA-256', buffer));
}

export async function sha256HexOfString(value: string): Promise<string> {
  return sha256Hex(new TextEncoder().encode(value));
}

export const SHA256_HEX_RE = /^[0-9a-f]{64}$/;

export function isSha256Hex(value: unknown): value is string {
  return typeof value === 'string' && SHA256_HEX_RE.test(value);
}

/**
 * hash ค่าที่อ่อนไหว (เช่น IP) พร้อม salt ก่อนเก็บลง audit log
 * ตัดเหลือ 32 ตัวอักษรเพราะพอสำหรับจับคู่เหตุการณ์ แต่ย้อนกลับไม่ได้
 */
export async function hashWithSalt(value: string, salt: string): Promise<string> {
  const digest = await sha256HexOfString(salt + ':' + value);
  return digest.slice(0, 32);
}

/** เทียบสตริงแบบใช้เวลาคงที่ ป้องกัน timing attack ตอนตรวจลายเซ็น */
export function timingSafeEqual(a: string, b: string): boolean {
  if (a.length !== b.length) return false;
  let diff = 0;
  for (let i = 0; i < a.length; i++) {
    diff |= a.charCodeAt(i) ^ b.charCodeAt(i);
  }
  return diff === 0;
}
